const { currencyFormat } = require("helper/numberHelper");
const moment = require("moment");
const { bgImageBase64 } = require("../../helper/constant")
// const url = 'https://localbalivillas.com/'

module.exports = { 
    CFGRecapInvoice({
        data
    }) {
        return `<!DOCTYPE html>
        <html>
            <head>
                <meta name="viewport" content="width=device-width">
                <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
                <title>Configroup Invoice</title>
                <link href="//netdna.bootstrapcdn.com/bootstrap/3.1.0/css/bootstrap.min.css" rel="stylesheet" id="bootstrap-css">
                <script src="//netdna.bootstrapcdn.com/bootstrap/3.1.0/js/bootstrap.min.js"></script>
                <script src="//code.jquery.com/jquery-1.11.1.min.js"></script>
                <style>
                  .bigfont {
                      font-size: 3rem !important;
                  }
                  .invoice{
                      width:970px !important;
                      min-height: 500px !important;
                      margin:50px auto;
                      background-image: url(${bgImageBase64});
                  }
                  .logo {
                      float:left;
                      padding-right: 10px;
                      margin:10px auto;
                  }

                  dt {
                      float:left;
                  }

                  dd {
                      float:left;
                      clear:right;
                  }

                  .customercard {
                      min-width:65%;
                  }

                  .itemscard {
                      min-width:98.5%;
                      margin-left:0.5%;
                  }

                  .logo {
                      max-width: 5rem;
                      margin-top: -0.25rem;
                  }

                  .invDetails {
                      margin-top: 0rem;
                  }

                  .pageTitle {
                      margin-bottom: -1rem;
                  }
                  .invoice-title h2, .invoice-title h3 {
                        display: inline-block;
                    }

                    .table > tbody > tr > .no-line {
                        border-top: none;
                    }

                    .table > thead > tr > .no-line {
                        border-bottom: none;
                    }

                    .table > tbody > tr > .thick-line {
                        border-top: 2px solid;
                    }
                    .no-break {
                        page-break-inside: avoid;
                        break-inside: avoid;
                    }
                </style>
            </head>
            <body class="" style="background-color: #f6f6f6; font-family: sans-serif; -webkit-font-smoothing: antialiased; font-size: 14px; line-height: 1.4; margin: 0; padding: 32px; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%;">
                <div class="invoice">
                    <div class="invoice-header">
                        <div class="ui left aligned grid">
                            <div class="row" style="display: flex; text-align: left">
                                <div style="width: 50%">
                                    <div>
                                        <h2>${data.custName ? data.custName.toUpperCase() : ''}</h2>
                                        <h4>${data.addressDetail ? data.addressDetail.streetName : ''}</h4>
                                    </div>
                                </div>
                                <div style="width: 50%; text-align: right">
                                    <div>
                                        <h3>${data.orderCode ? data.orderCode.toUpperCase() : ''}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ui segment cards">
                        <div class="ui segment itemscard">
                        <div class="content">
                            <table class="ui celled table">
                            <thead>
                                <tr>
                                <th>Keterangan</th>
                                <th class="text-center colfix">Qty</th>
                                <th class="text-center colfix">Harga Kilo</th>
                                <th class="text-center colfix">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>
                                    ${data.eventId.eventName}
                                </td>
                                <td class="text-right">
                                    <span class="mono">${data.qty} ${data.qtyType}</span>
                                </td>
                                <td class="text-right">
                                    <span class="mono">${currencyFormat(data.price)}</span>
                                </td>
                                <td class="text-right">
                                    <span class="mono">${currencyFormat(data.jastipTotal)}</span>
                                    <br>
                                    <small class="text-muted"></small>
                                </td>
                                </tr>
                            </tbody>
                            <tfoot class="full-width">
                        <tr>
                    </tfoot>
                    </table>
                    </div>
                    </div>
                    <div class="ui card">
                        <div class="content center aligned text segment">
                            <span class="mono">Note : </span>
                            ${data.shoppingRequest ? data.shoppingRequest.map(v => {
                                return (
                                    (v.totalPrice > 0) ?
                                    `<div class="content center aligned text segment">
                                        <span class="mono">Note ${v.name}: Rp ${currencyFormat(v.totalPrice)} </span>
                                    </div>`
                                    :`<div></div>`
                                )
                            }).join(' ') : ''}
                        </div>
                    </div>
                    <div class="ui card" style="padding-top: 10px;">
                        <div class="content center aligned text segment">
                            <span class="mono">Fee Lainnya ( /item) : </span>
                            ${data.additionalFee ? data.additionalFee.map(v => {
                                return (
                                    (v.totalPrice > 0) ?
                                    `<div class="content center aligned text segment">
                                        <span class="mono">${v.information}: Rp ${currencyFormat(v.totalPrice)} </span>
                                    </div>`
                                    :`<div></div>`
                                )
                            }).join(' ') : ''}
                        </div>
                    </div>
                     <div class="no-break">
                        <div style="display: flex; width:100%; text-align:right; margin-top: 20px; padding-top: 10px; border-top: thick double #e4e4e4;">
                            <div style="width: 80%"><span class="mono" style="font-weight: bold">Total</span></div>
                            <div style="width: 20%"><span class="mono">${currencyFormat(data.grandTotalPrice + Number(data.discount || 0))}</span></div>
                        </div>
                        <div style="display: flex; width:100%; text-align:right; margin-top: 5px; padding-top: 5px; border-top:">
                            <div style="width: 80%"><span class="mono" style="font-weight: bold">Discount</span></div>
                            <div style="width: 20%"><span class="text-muted">${(data.discount && data.discount > 0) ? `( ${currencyFormat(data.discount)} )` : '-'}</span></div>
                        </div>
                        <div style="display: flex; width:100%; text-align:right; margin-top: 5px; padding-top: 5px; border-top:">
                            <div style="width: 80%"><span class="mono" style="font-weight: bold">DP Paid</span></div>
                            <div style="width: 20%"><span class="text-muted">${(data.downPayment && data.downPaymentStatus.paid == true && data.dp > 0) ? `( ${currencyFormat(data.dp)} )` : '-'}</span></div>
                        </div>
                        <div style="display: flex; width:100%; text-align:right; margin-top: 20px; padding-top: 10px; border-top: thick double #e4e4e4;">
                            <div style="width: 80%"><span class="mono" style="font-weight: bold">Grand Total</span></div>
                            <div style="width: 20%"><span class="mono">${currencyFormat(data.grandTotalPrice - Number(data.dp || 0))}</span></div>
                        </div>
                        <div style="margin-top: 100px">
                            <div style="font-size: 13px">Transfer hanya via : </div>
                            <div>8280-2952-90 BCA a.n sylvia wongso</div>
                            <div style="font-size: 13px">Diluar dari nomor rekening yg tercantum, Confi tidak bertanggung jawab</div>
                        </div>
                    </div>
            </body>
        </html>`
    },
    CFGRecapInvoicePO({
        data
    }) {
        console.log('here data', data)
        let totalDPPaid = 0
        data.poProducts.map(v => { if (v.dpPaid) { totalDPPaid += v.dp } })

        return `<!DOCTYPE html>
        <html>
            <head>
                <meta name="viewport" content="width=device-width">
                <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
                <title>Configroup Invoice</title>
                <link href="//netdna.bootstrapcdn.com/bootstrap/3.1.0/css/bootstrap.min.css" rel="stylesheet" id="bootstrap-css">
                <script src="//netdna.bootstrapcdn.com/bootstrap/3.1.0/js/bootstrap.min.js"></script>
                <script src="//code.jquery.com/jquery-1.11.1.min.js"></script>
                <style>

                  .bigfont {
                      font-size: 3rem !important;
                  }
                  .invoice{
                      width:970px !important;
                      min-height: 500px !important;
                      margin:50px auto;
                      background-image: url(${bgImageBase64});
                  }

                  .logo {
                      float:left;
                      padding-right: 10px;
                      margin:10px auto;
                  }

                  dt {
                      float:left;
                  }

                  dd {
                      float:left;
                      clear:right;
                  }

                  .customercard {
                      min-width:65%;
                  }

                  tr {
                    page-break-inside: avoid;
                    break-inside: avoid;
                  }

                  .itemscard {
                      min-width:98.5%;
                      margin-left:0.5%;
                  }

                  .logo {
                      max-width: 5rem;
                      margin-top: -0.25rem;
                  }

                  .invDetails {
                      margin-top: 0rem;
                  }

                  .pageTitle {
                      margin-bottom: -1rem;
                  }
                  .invoice-title h2, .invoice-title h3 {
                        display: inline-block;
                    }

                    .table > tbody > tr > .no-line {
                        border-top: none;
                    }

                    .table > thead > tr > .no-line {
                        border-bottom: none;
                    }

                    .table > tbody > tr > .thick-line {
                        border-top: 2px solid;
                    }
                    .no-break {
                        page-break-inside: avoid;
                        break-inside: avoid;
                    }
                </style>
            </head>
            <body class="" style="background-color: #f6f6f6; font-family: sans-serif; -webkit-font-smoothing: antialiased; font-size: 14px; line-height: 1.4; margin: 0; padding: 32px; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%;">
                <div class="container invoice">
                    <div class="invoice-header">
                        <div class="ui left aligned grid">
                            <div class="row" style="display: flex; text-align: left">
                                <div style="width: 50%">
                                    <div>
                                        <h2>${data.custName ? data.custName.toUpperCase() : ''}</h2>
                                        <h4>${data.addressDetail ? data.addressDetail.streetName : ''}</h4>
                                    </div>
                                </div>
                                <div style="width: 50%; text-align: right">
                                    <div>
                                        <h3>${data.orderCode ? data.orderCode.toUpperCase() : ''}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ui segment cards">
                        <div class="ui segment itemscard">
                        <div class="content">
                            <table class="ui celled table">
                            <thead>
                                <tr>
                                <th>Keterangan</th>
                                <th class="text-center colfix">Qty</th>
                                <th class="text-center colfix">Harga Kilo</th>
                                <th class="text-center colfix">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${data.poProducts.map(v => {
                                        return (
                                            `<tr>
                                            <td>
                                                <img width="100" height="100" src="${v.image}"/>
                                                ${v.name}
                                            </td>
                                            <td class="text-right">
                                                <span class="mono">${v.qty} ${v.qtyType}</span>
                                            </td>
                                            <td class="text-right">
                                                <span class="mono">${currencyFormat(v.price)}</span>
                                            </td>
                                            <td class="text-right">
                                                <span class="mono">${currencyFormat(v.totalPrice)}</span>
                                                <br>
                                                <small class="text-muted">${v.dpPaid ? `DP: ( ${currencyFormat(v.dp)} )` : ''}</small>
                                            </td>
                                            </tr>`
                                        )
                                    }).join(' ')
                                }
                            </tbody>
                            <tfoot class="full-width">
                        <tr>
                    </tfoot>
                    </table>
                        </div>
                        </div>
                    </div>
                    <div class="no-break">
                        <div style="display: flex; width:100%; text-align:right; margin-top: 20px; padding-top: 10px; border-top: thick double #e4e4e4;">
                            <div style="width: 80%"><span class="mono" style="font-weight: bold">Total</span></div>
                            <div style="width: 20%"><span class="mono">${currencyFormat(data.totalPrice)}</span></div>
                        </div>
                        <div style="display: flex; width:100%; text-align:right; margin-top: 5px; padding-top: 5px; border-top:">
                            <div style="width: 80%"><span class="mono" style="font-weight: bold">DP Paid</span></div>
                            <div style="width: 20%"><span class="text-muted">${totalDPPaid > 0 ? `( ${currencyFormat(totalDPPaid)} )` : '-'}</span></div>
                        </div>
                        <div style="display: flex; width:100%; text-align:right; margin-top: 20px; padding-top: 10px; border-top: thick double #e4e4e4;">
                            <div style="width: 80%"><span class="mono" style="font-weight: bold">Grand Total</span></div>
                            <div style="width: 20%"><span class="mono">${currencyFormat(data.totalPrice - totalDPPaid)}</span></div>
                        </div>
                        <div style="margin-top: 100px">
                            <div style="font-size: 13px">Transfer hanya via : </div>
                            <div>864-547-2060 BCA a.n sylvia wongso</div>
                            <div style="font-size: 13px">Diluar dari nomor rekening yg tercantum, Confi tidak bertanggung jawab</div>
                        </div>
                    </div>
            </body>
        </html>`
    },
}